import React from 'react';
import { Box, Typography } from '@mui/material';
import { useAuth } from '@healthdesk/shared-hooks';
import ClinicHealthDashboard from '../components/analytics/ClinicHealthDashboard';

const ClinicHealthPage = () => {
  const { hasValidSubscription } = useAuth();

  return (
    <div className="inner">
      <Typography
        variant="h4"
        component="h2"
        sx={{ mt: { xs: 1, sm: 5 }, mb: 1 }}
      >
        Clinic Health
      </Typography>

      <Typography variant="body1" sx={{ display: 'block', mb: 4 }}>
        Track patient volume, wait times, and trends to keep your clinic running
        at its best.
      </Typography>

      <Box>
        <ClinicHealthDashboard previewMode={!hasValidSubscription} />
      </Box>
    </div>
  );
};

export default ClinicHealthPage;
